import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { OfflineView } from '@report/+offline/offline.component';
import { BrandLogo } from '@shared/components/brand-logo/brand-logo.component';
import { BasicModule } from '@shared/modules/basic.module';

@NgModule({
  bootstrap: [],
  declarations: [OfflineView],
  exports: [],
  imports: [BasicModule, MatIconModule, BrandLogo],
  providers: [],
})
export class OfflineModule {}
